import { HttpClient } from '@angular/common/http';
import { Intervallo } from 'app/model/ambulatorio';
import { IID, RESTArray } from '../angular-rest';

export class Giorno extends RESTArray<Intervallo> {
	constructor($http: HttpClient, uri: string) {
		super($http, uri, (h, u, r) => new Intervallo(h, u, r));
	}
}

export class GiornoScT extends RESTArray<Intervallo> {

	constructor($http: HttpClient, uri: string, giorno: number) {
		super($http, uri, (h, u, r) => new Intervallo(h, u, r, giorno));
	}

	getUri: (id: IID<string>) => ''
}

export interface Settimana extends Array<Giorno>, WID { }

export interface WID {
	settimana: string;
	tag?: string;
}



// WEBPACK FOOTER //
// ./src/app/model/time.ts